import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import {
  blockingFilters,
  loadIdentityReviewQueue,
  queueCompanyPageSize,
} from "@/admin/identity-reviews/identity-review-data"
import { IdentityReviewQueuePage } from "@/admin/identity-reviews/queue-page"
import { reviewKinds } from "@/admin/identity-reviews/review-presentation"

const searchSchema = z.object({
  blocking: z.enum(blockingFilters).default("all"),
  kind: z.enum(["all", ...reviewKinds]).default("all"),
  query: z.string().default(""),
  companyLimit: z.number().int().positive().default(queueCompanyPageSize),
})

const IdentityReviewQueueRoute = () => {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  return (
    <IdentityReviewQueuePage
      queue={Route.useLoaderData()}
      {...search}
      onFilter={(next) =>
        void navigate({
          // A new filter starts again from the first page.
          search: { ...search, companyLimit: queueCompanyPageSize, ...next },
          replace: true,
          resetScroll: false,
        })
      }
    />
  )
}

export const Route = createFileRoute(
  "/_terminalAdmin/terminal/admin/identity-reviews/"
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ deps }) => loadIdentityReviewQueue({ data: deps }),
  component: IdentityReviewQueueRoute,
})
